import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { ApiError } from 'types/utils/api-response';
import { api } from 'constants/api';
import { ApiResponse } from 'types/utils/api-response';
import { MutationOptions } from 'types/utils/mutation-options';

export type SetUserStatusResponseType = {};

export const useSetUserStatus = (
  options?: MutationOptions<
    SetUserStatusResponseType,
    { id: string; isActive: boolean },
    AxiosError<ApiError>
  >
) =>
  useMutation({
    mutationFn: async ({ id, isActive }) => {
      const { data } = await api.patch<ApiResponse<SetUserStatusResponseType>>(
        `/user/${id}`,
        {
          is_active: isActive,
        }
      );

      return data.data;
    },
    ...options,
  });
